export function convertFirstCharToUppercase (str) 
{
  if(str && str !== "" )
  {
    return str[0].toUpperCase() + str.substr(1);
  }
  else
  {
    return str;
  }
}